import React, { FC } from 'react';
import {
  Modal,
  Content,
  IconWrapper,
  Title,
  SuccessText,
  Button,
  CheckIcon,
} from './styles';
import { Props } from './types';

const ModalNotifications: FC<Props> = ({ modalNotifications, handleClose }) => {
  // Should be displayed only first message
  // And only one at a time
  if (modalNotifications.length) {
    return (
      <Modal open handleClose={handleClose}>
        <Content>
          <IconWrapper>
            <CheckIcon />
          </IconWrapper>
          <Title>{modalNotifications[0].heading}</Title>
          <SuccessText>{modalNotifications[0].body}</SuccessText>
          <Button color="primary" variant="floating" onClick={handleClose}>
            Close
          </Button>
        </Content>
      </Modal>
    );
  }
  return null;
};

export default ModalNotifications;
